<script>
export default {
  computed: {
    getSelectedProds() {
      return this.$store.getters.getSelectedProducts;
    },
    getShoppingTotal() {
      let totalAmount = 0;

      this.$store.getters.getSelectedProducts.forEach((prod) => {
        prod.options.forEach((op) => {
          totalAmount += op.quantity * op.unitPrice;
        });
      });

      return totalAmount;
    },
    getShippingTotal() {
      return this.$store.getters.getTotalShipping;
    },
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/mixins/checkout_mixins.vue